import { render, staticRenderFns } from "./AppointmentPreloader.vue?vue&type=template&id=73ddd826&"
import script from "./AppointmentPreloader.vue?vue&type=script&lang=js&"
export * from "./AppointmentPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ddd826')) {
      api.createRecord('73ddd826', component.options)
    } else {
      api.reload('73ddd826', component.options)
    }
    module.hot.accept("./AppointmentPreloader.vue?vue&type=template&id=73ddd826&", function () {
      api.rerender('73ddd826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentPreloader.vue"
export default component.exports